// Author lidongxu
// Date 2024-02-22 10:47:49

import * as model from "@/model/sithMes/stool/SithMesStoolPrApplicationShippingDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStoolPrApplicationShippingDetail(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
    })
    .buildStore()
